import { createContext } from "react";

/**
 * The element beside the business switcher that the shell draws its actions
 * into (ORDR-209): "Onboard business" today.
 *
 * The switcher is the provider's and the onboarding gate is the shell's, which
 * knows the acting node. A slot lets the shell keep the one gate it already
 * has and still draw the button where the switcher is, rather than the
 * provider restating that gate from capabilities it does not hold.
 *
 * `null` outside the staff door, and before the slot has mounted: nothing is
 * drawn then.
 */
export const BusinessActionsSlot = createContext<HTMLElement | null>(null);
